import React from 'react'
import { Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import './index.scss'

export default function AdminOnlyContainer({ children, style }) {
    return (
        <div style={style} className="admin-only-container">
            <Tooltip title="Only visible for admin">
                <InfoCircleOutlined className="admin-only-info" />
            </Tooltip>
            {children}
        </div>
    )
}
